/**
 * Better Auth Client Configuration
 * Frontend auth client for LegalSyncUp
 *
 * Uses the Better Auth client to interact with the auth API
 */

import { createAuthClient } from 'better-auth/react';

/**
 * Get the base URL for auth API calls
 * Uses empty string to make requests relative to current origin
 * This works in both development and production environments
 */
const getBaseUrl = (): string => {
  // Always use relative URLs to avoid cross-origin issues
  // The browser will resolve these relative to the current page origin
  // In dev: http://localhost:5173/api/auth/...
  // In prod: https://legalsyncup.com/api/auth/...
  return '';
};

/**
 * Better Auth client for React
 * Provides hooks and utilities for authentication
 *
 * Note: baseURL is empty string to use relative URLs,
 * ensuring requests go to the same origin as the page
 */
export const authClient = createAuthClient({
  baseURL: getBaseUrl(),
  // Ensure cookies are sent with requests
  fetchOptions: {
    credentials: 'include',
  },
});

/**
 * Auth hooks and utilities
 */
export const {
  signIn,
  signUp,
  signOut,
  useSession,
  getSession,
} = authClient;

/**
 * Types for auth
 */
export type AuthSession = Awaited<ReturnType<typeof getSession>>;
export type AuthUser = NonNullable<AuthSession>['user'];
